$(document).ready(function () {
    let ajaxLockActive = false;

    const ajaxPathProductCategory = '/action/waiter-app/product-category';
    const ajaxPathProductCategorySearchProducts = '/products';
    const ajaxPathProductCategoryUpdateSortPriority = '/sort-priority';

    function updateSortPriority() {
        if (ajaxLockActive === true) {
            return;
        }

        ajaxLockActive = true;

        const productCategoryIds = [];
        $('#wa_product_category_wrapper .wa_product_category_item', document).each(function (_, element) {
            productCategoryIds.push($(element).attr('data-id'));
        });

        $.ajax({
            type: 'PATCH',
            url: ajaxPathProductCategory + ajaxPathProductCategoryUpdateSortPriority,
            data: {
                product_category_ids: productCategoryIds
            },
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper #wa_product_categories_list_panel', document).notify('Sorteringsprioritet er lagret', {
                position: "bottom center",
                className: 'success'
            });
        }).error(function (data) {
            $('#wa_product_category_wrapper #wa_product_categories_list_panel', document).notify('Sorteringsprioritet er ikke lagret', {
                position: "bottom center",
                className: 'error'
            });
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    function initSortable() {
        if ($("#wa_product_category_wrapper #wa_product_categories_list", document).length && $("#wa_product_category_wrapper .wa_product_category_item", document).length) {
            $("#wa_product_category_wrapper #wa_product_categories_list", document).sortable('destroy');
            new Sortable($("#wa_product_category_wrapper #wa_product_categories_list", document)[0], {
                axis: 'y',
                cursor: "move",
                tolerance: "pointer",
                onUpdate: function (e) {
                    updateSortPriority();
                }
            });
        }
    }

    initSortable();

    function getProductItemRow(itemData) {
        return `<tr>
                        <td>${itemData.product_name}</td>
                        <td>${itemData.varenummer}</td>
                        <td>
                            <button class="btn wa_product_category_toggle_product_btn btn-danger"
                            data-product-id="${itemData.product_id}"
                            data-added-to-category="1">Slett</button>
                        </td>
                    </tr>`;
    }

    $(document).on('click', '#wa_product_category_wrapper #wa_product_category_btn_create', function () {
        if (ajaxLockActive) {
            return false;
        }

        const name = $('#wa_product_category_wrapper #wa_product_category_name', document).val();
        const iconName = $('#wa_product_category_wrapper #wa_product_category_icon_preview', document).attr('data-icon-name');

        const productIds = [];
        $('#wa_product_category_wrapper .wa_product_category_toggle_product_btn', document).each(function (_, element) {
            const productId = $(element).attr('data-product-id');
            const isAddedToCategory = $(element).attr('data-added-to-category');

            if (isAddedToCategory == 1) {
                productIds.push(productId);
            }
        });

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'POST',
            url: ajaxPathProductCategory,
            data: {
                name: name,
                icon_name: iconName,
                product_ids: productIds,
            },
            dataType: 'json'
        }).success(function (data) {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            showErrors('Kunne ikke opprette produktkategori', data, '#wa_product_category_wrapper');
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper #wa_product_category_btn_update', function () {
        if (ajaxLockActive) {
            return false;
        }

        const productCategoryId = $('#wa_product_category_wrapper #wa_product_category_id', document).val();
        const name = $('#wa_product_category_wrapper #wa_product_category_name', document).val();
        const iconName = $('#wa_product_category_wrapper #wa_product_category_icon_preview', document).data('icon-name');

        const productIds = [];
        $('#wa_product_category_wrapper .wa_product_category_toggle_product_btn', document).each(function (_, element) {
            const productId = $(element).attr('data-product-id');
            const isAddedToCategory = $(element).attr('data-added-to-category');

            if (isAddedToCategory == 1) {
                productIds.push(productId);
            }
        });

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'POST',
            url: `${ajaxPathProductCategory}/${productCategoryId}`,
            data: {
                name: name,
                icon_name: iconName,
                product_ids: productIds,
            },
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper', document).html(data.html);
            $('#wa_product_category_btn_update', document).notify('Produktkategori er oppdatert', {
                position: "right",
                className: 'success'
            });
            initSortable();
        }).error(function (data) {
            showErrors('Kunne ikke oppdatere produktkategori', data, '#wa_product_category_wrapper');
        }).always(function () {
            hidePreloader();
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper #wa_product_category_btn_delete', function () {
        if (ajaxLockActive) {
            return false;
        }

        const productCategoryName = $('#wa_product_category_wrapper #wa_product_category_name', document).val();

        if (!confirm(`Vil du slette produktkategori "${productCategoryName}"?`)) {
            return;
        }

        const productCategoryId = $('#wa_product_category_wrapper #wa_product_category_id', document).val();

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'DELETE',
            url: `${ajaxPathProductCategory}/${productCategoryId}`,
            dataType: 'json'
        }).success(function (data) {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            showErrors('Kunne ikke slette produktkategori', data, '#wa_product_category_wrapper');
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper .wa_product_category_toggle_product_btn', function () {
        if (ajaxLockActive) {
            return false;
        }

        const isAddedToCategory = $(this).attr('data-added-to-category');

        const btn = $(this);

        if (isAddedToCategory == 0) {
            btn.text('Slett');
            btn.attr('data-added-to-category', 1);
            btn.removeClass('btn-primary').addClass('btn-danger');
        }

        if (isAddedToCategory == 1) {
            btn.text('Legg til');
            btn.attr('data-added-to-category', 0);
            btn.removeClass('btn-danger').addClass('btn-primary');
        }

        return false;
    });

    $(document).on('input', '#wa_product_category_wrapper #wa_products_list_search_input', function () {
        if (ajaxLockActive) {
            return false;
        }

        const searchInput = $(this);
        const productCategoryId = $('#wa_product_category_id', document).val();
        const searchString = searchInput.val();

        const excludeProductIds = [];
        $('#wa_product_category_wrapper .wa_product_category_toggle_product_btn', document).each(function (_, element) {
            const productId = $(element).attr('data-product-id');
            excludeProductIds.push(productId);
        });

        $.ajax({
            type: 'POST',
            url: `${ajaxPathProductCategory}/${productCategoryId}${ajaxPathProductCategorySearchProducts}`,
            data: {
                search_string: searchString,
                exclude_product_ids: JSON.stringify(excludeProductIds),
            },
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper #wa_products_list_search_result', document).html(data.html);
        }).error(function () {
            searchInput.notify('Feil oppsto', {
                position: "top",
                className: 'error'
            });
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper .add-product', function () {
        const itemData = {
            product_id: $(this).attr('data-product-id'),
            product_name: $(this).attr('data-product-name'),
            varenummer: $(this).attr('data-varenummer')
        }

        $('#wa_product_category_wrapper #wa_products_list_empty', document).remove();

        const tbody = $('#wa_product_category_wrapper #wa_products_list table tbody', document);

        tbody.append(getProductItemRow(itemData));

        $(this).remove();

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper .wa_product_category_item', function () {
        if (ajaxLockActive) {
            return false;
        }

        const productCategoryId = $(this).attr('data-id');

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'GET',
            url: `${ajaxPathProductCategory}/${productCategoryId}`,
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper #wa_product_category_form', document).html(data.html);
        }).error(function (data) {
            showErrors('Kunne ikke hente produktkategori', data, '#wa_product_category_wrapper');
        }).always(function () {
            hidePreloader();
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper .wa_product_category_icon', function () {
        const iconName = $(this).attr('data-icon-name');

        $('#wa_product_category_wrapper #wa_product_category_icon_preview', document).attr('data-icon-name', iconName);
        $('#wa_product_category_wrapper #wa_product_category_icon_preview', document).html(`<img src="includes/waiterApp/productCategory/icons/${iconName}" alt="${iconName}">`);
    });

    $(document).on('click', '#wa_product_category_wrapper #wa_product_categories_search_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        const searchInput = $('#wa_product_category_wrapper #wa_product_categories_search_input', document);
        const searchString = searchInput.val();

        $.ajax({
            type: 'GET',
            url: ajaxPathProductCategory,
            data: {
                search_string: searchString,
            },
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper #wa_product_categories_list', document).html(data.html);
        }).error(function () {
            searchInput.notify('Feil oppsto', {
                position: "top",
                className: 'error'
            });
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });
});